import { SidebarProvider } from "../context/SidebarContext";
import { useSidebar } from "../context/useSidebar";
import { Outlet } from "react-router";
import AppHeader from "./AppHeader";
import Backdrop from "./Backdrop";
import AppSidebar from "./AppSidebar";
import ImpersonationBanner from "../components/Admin/ImpersonationBanner";
import EmailVerificationBanner from "./EmailVerificationBanner";
import FreeTrialBanner from "./FreeTrialBanner";
import { useAuth } from "../contexts/useAuth";
import { isAppRedesignEnabled } from "../config/features";
import RedesignLayout from "./redesign/RedesignLayout";

const LayoutContent: React.FC = () => {
  const { isExpanded, isHovered, isMobileOpen } = useSidebar();
  useAuth();

  const showSidebar = true;

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900">
      <div className="xl:flex">
        {showSidebar && (
          <div>
            <AppSidebar />
            <Backdrop />
          </div>
        )}
        <div
          className={`min-w-0 flex-1 transition-all duration-300 ease-in-out ${
            showSidebar && (isExpanded || isHovered) ? "lg:ml-[290px]" : showSidebar ? "lg:ml-[90px]" : "ml-0"
          } ${isMobileOpen ? "ml-0" : ""} bg-gray-50 dark:bg-gray-900`}
        >
          {/* Rendered inside the content column (not above the flex row) so the
              fixed sidebar never overlaps it. Returns null when not impersonating. */}
          <ImpersonationBanner />
          <FreeTrialBanner />
          <EmailVerificationBanner />
          <AppHeader />
          <div className="p-4 mx-auto max-w-(--breakpoint-2xl) md:p-6 bg-gray-50 dark:bg-gray-900">
            <Outlet />
          </div>
        </div>
      </div>
    </div>
  );
};

const AppLayout: React.FC = () => {
  // The redesign is a whole different shell, not a variant of this one — it has no collapse state,
  // no backdrop and no banner stack — so it replaces LayoutContent outright rather than branching
  // inside it. With the gate off, production renders exactly what it rendered before.
  if (isAppRedesignEnabled()) {
    return <RedesignLayout />;
  }

  return (
    <SidebarProvider>
      <LayoutContent />
    </SidebarProvider>
  );
};

export default AppLayout;
